import { Building, Business, Floor, Reports, TypeOfJob } from '@admin/models';
import {
  BuildingService,
  BusinessService,
  FloorService,
  ReportPlaceService,
  WorkplaceTypeService,
} from '@admin/services';
import { DashboardService } from '@admin/services/dashboard.service';
import { NgFor, NgIf } from '@angular/common';
import {
  Component,
  DestroyRef,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatCardContent } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { LogoService, ToastAlertService } from '@core/index';
import { ButtonComponent, TitleComponent } from '@shared/components';
import html2canvas from 'html2canvas';
import * as jspdf from 'jspdf';

import { Cookies } from 'typescript-cookie';
declare let h337: any;
const MOUSE_CIRCLE_RADIUS = 25;
const MOUSE_CIRCLE_TRANSL_RADIUS = 10;
const HEATMAP_HEIGHT = 350;
const HEATMAP_WIDTH = 350;
const HEATMAP_SIZE = 350; // Tamaño del heatmap y de la imagen

@Component({
  selector: 'app-heat-map-image',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ButtonComponent,
    MatPaginator,
    MatTableModule,
    NgFor,
    NgIf,
    TitleComponent,
    MatCardContent,
  ],
  templateUrl: './heat-map-image.component.html',
  styleUrl: './heat-map-image.component.scss',
})
export class HeatMapImageComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  title = 'mapp';
  private logoService = inject(LogoService);
  public selectValueCompani = -1; //VALOR SELECCIONADO DE LA COMPANI O EMPRESA
  public valueNivel = -1; //VALOR SELECCIONADO DE LA COMPANI O EMPRESA
  public bussinesForLogo: Business[] = [];

  gradientCfg = {
    0.15: '#6ad180', // green
    0.25: '#7cd573',
    0.35: '#90d865',
    0.45: '#a4da57',
    0.55: '#badc48',
    0.65: '#c9cf35',
    0.75: '#d6c226',
    0.8: '#e2b41c',
    0.85: '#e2961d',
    0.9: '#dd7826',
    0.95: '#d25c30',
    1.0: '#c24039', // highest red
  };
  heatmap: any = null;
  coordinates: Array<Coordinate> = [];
  selectedCoordinates: Array<Coordinate> = [];
  // heatmapContainer?: HTMLElement;
  // tooltip?: HTMLElement;
  // mouseCircle?: HTMLElement;
  heatmapContainer: HTMLElement | null = null;
  tooltip: HTMLElement | null = null;
  mouseCircle: HTMLElement | null = null;
  isMouseInsideHeatmap = false;
  xMinCoord: number;
  yMinCoord: number;
  xMaxCoord: number;
  yMaxCoord: number;
  constructor(
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    this.dataSource = new MatTableDataSource();
    this.xMinCoord = 0;
    this.yMinCoord = 0;
    this.xMaxCoord = 0;
    this.yMaxCoord = 0;
  }

  //services
  private businessServices = inject(BusinessService);
  private destroyRef = inject(DestroyRef);
  #DashboardService = inject(DashboardService);
  building = inject(BuildingService);
  workplacetype = inject(WorkplaceTypeService);
  private alertService = inject(ToastAlertService);
  floor = inject(FloorService);
  private reportsService = inject(ReportPlaceService);
  private floorService = inject(FloorService);

  cookieRole = Cookies.get('role');
  businessId: number = -1;
  buildingId: number = -1;
  floorId: number = -1;
  workPlaceId: number = -1;
  filter: string = 'lastMonth';
  private TypeWorkplace = signal(0);
  dataSource: MatTableDataSource<Reports>;
  imgSource = signal<string>('');

  //HEATMAP
  imageWidth: number = 0;
  imageHeight: number = 0;
  porcentaje: number = 0.8;

  //data
  public bussines: Business[] = [];
  edificios: Building[] = [];
  puestos: TypeOfJob[] = [];
  floors: Floor[] = [];
  rangeFilter = signal([
    { value: 'lastWeek', name: 'Última semana' },
    { value: 'lastMonth', name: 'Último mes' },
    { value: 'lastThreeMonths', name: 'Últimos 3 meses' },
    { value: 'lastYear', name: 'Último año' },
  ]);
  displayedColumns: string[] = ['building', 'floor', 'workplace', 'frequency'];
  ngOnInit(): void {
    this.getBusiness();
    const business = Cookies.get('bussinesId')?.toString();
    if (business !== null) {
      this.ObtenerEdificios(parseInt(business!));
      this.ObtenerPuestos(parseInt(business!));
    }
    //this.generateCoordinates();
    this.calculateMinMaxCoord();
    const heatmapConfig = {
      container: document.querySelector('#heatmapContainer'),
      opacity: 0.8,
      radius: 15,
      visible: true,
      gradient: this.gradientCfg,
      backgroundColor: 'inherit',
    };
    this.heatmap = h337.create(heatmapConfig);
    this.heatmap.setData({ max: 30, data: this.coordinates });

    this.heatmapContainer = document.querySelector('#heatmapContainer');
    this.tooltip = this.renderer.createElement('div');
    this.renderer.addClass(this.tooltip, 'heatmap-tooltip');
    this.renderer.setStyle(this.tooltip, 'display', 'none');
    this.renderer.setStyle(this.tooltip, 'transform', 'translate(39px, 489px)');
    this.mouseCircle = this.renderer.createElement('div');
    this.renderer.addClass(this.mouseCircle, 'mouseCircle');
    this.renderer.setStyle(this.mouseCircle, 'display', 'none');
    this.renderer.setStyle(
      this.mouseCircle,
      'transform',
      'translate(39px, 489px)'
    );
    this.renderer.appendChild(this.heatmapContainer, this.tooltip);
    this.renderer.appendChild(this.heatmapContainer, this.mouseCircle);
  }
  updateHeatmap(): void {
    if (this.heatmap) {
      this.heatmap.setData({ max: 100, data: this.coordinates });
    }
  }
  refreshHeatmap(): void {
    // Llama a este método para actualizar el heatmap
    this.coordinates = []; // Limpia las coordenadas actuales
    this.generateCoordinates(); // Genera nuevas coordenadas
    this.updateHeatmap(); // Actualiza el heatmap con las nuevas coordenadas
  }
  private getBusiness() {
    this.businessServices
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000 || request.code === 40009) {
            this.bussines = request.reply;
            this.bussinesForLogo = request.reply;
          }
        },
      });
    this.edificios = [];
    this.puestos = [];
    this.floors = [];
    this.buildingId = -1;
    this.floorId = -1;
    this.workPlaceId = -1;
  }
  ObtenerEdificios(businessId: number) {
    this.valueNivel = -1;
    this.loadLogo();
    this.imgSource.set('');
    this.coordinates = [];
    this.updateHeatmap();
    this.edificios = [];
    this.puestos = [];
    this.floors = [];
    this.buildingId = -1;
    this.floorId = -1;
    this.workPlaceId = -1;
    this.businessId = businessId;
    console.log(this.businessId);
    this.getReservationsGraphic();
    this.building.getBuildings(businessId).subscribe(response => {
      if (response.status) {
        this.edificios = response.reply;
      } else {
        console.error('Error al obtener los los edificios:', response.detail);
      }
    });

    this.ObtenerPuestos(this.businessId);
  }
  ObtenerPuestos(businessId: number) {
    this.businessId = businessId;
    this.workplacetype.getWorkplaces(businessId).subscribe(response => {
      if (response.status) {
        this.puestos = response.reply;
      } else {
        this.alertService.error(response.detail);
      }
    });
  }
  selectType(type: number): void {
    this.TypeWorkplace.set(type);
    this.getReservationsGraphic();
  }
  async selectFloor(floor: number) {
    this.floorId = floor;
    this.getReservationsGraphic();
    this.imgSource.set('');
    this.coordinates = [];
    await this.updateHeatmap();
    await this.chargeImage();
  }
  chargueFloorByBuilding(buldingid: number) {
    this.imgSource.set('');
    this.coordinates = [];
    this.updateHeatmap();
    this.floors = [];
    this.floorId = -1;
    this.floor
      .getFloorsByBuilding(buldingid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.floors = resp.reply || [];
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
    this.getReservationsGraphic();
  }
  inicio = '';
  fin = '';
  getReservationsGraphic() {
    if (!isNaN(this.businessId) && this.businessId !== -1) {
      const business = Cookies.get('bussinesId')?.toString();
      let formData: any = {
        filter: this.filter,
        businessId: this.businessId !== -1 ? this.businessId : undefined,
        workPlaceId: this.workPlaceId !== -1 ? this.workPlaceId : undefined,
        buildingId: this.buildingId !== -1 ? this.buildingId : undefined,
        floorId: this.floorId !== -1 ? this.floorId : undefined,
      };
      console.log('formdata', formData);
      if (this.cookieRole !== 'SYSADMIN') {
        if (business !== null) {
          formData.businessId = business;
        }
      }
      if (
        !isNaN(this.businessId) &&
        this.businessId !== -1 &&
        this.businessId !== null
      ) {
        formData.businessId = this.businessId;
      } else {
        delete formData.businessId;
      }

      if (formData.workPlaceId === -1) {
        delete formData.workPlaceId;
      }
      if (formData.buildingId === -1) {
        delete formData.buildingId;
      }
      if (formData.floorId === -1) {
        delete formData.floorId;
      }
      console.log(formData);
      this.reportsService.getDashboardReport(formData).subscribe({
        next: (resp: any) => {
          // this.fin = resp.reply.endDate;
          // this.inicio = resp.reply.startDate;
          // console.log('data con inicioOOOOOOO', this.inicio);
          // console.log('data con finalOOOOOOOOO', this.fin);
          if (resp.code === 10000 || resp.code === 40009) {
            if (resp.reply && resp.reply.length > 0) {
              this.dataSource = new MatTableDataSource(resp.reply);
              this.dataSource.paginator = this.paginator;
            } else {
              this.dataSource = new MatTableDataSource();
            }
          } else {
            this.alertService.error(resp.detail);
            this.dataSource = new MatTableDataSource();
          }
        },
      });
      if (this.imgSource() !== '') {
        this.refreshHeatmap();
      }
    } else {
      this.dataSource = new MatTableDataSource();
    }
  }
  async generateCoordinates() {
    this.inicio = '';
    this.fin = '';
    if (!isNaN(this.businessId) && this.businessId !== -1) {
      const business = Cookies.get('bussinesId')?.toString();
      let formData: any = {
        filter: this.filter,
        businessId: this.businessId !== -1 ? this.businessId : undefined,
        workPlaceId: this.workPlaceId !== -1 ? this.workPlaceId : undefined,
        buildingId: this.buildingId !== -1 ? this.buildingId : undefined,
        floorId: this.floorId !== -1 ? this.floorId : undefined,
      };
      console.log('formdata', formData);
      if (this.cookieRole !== 'SYSADMIN') {
        if (business !== null) {
          formData.businessId = business;
        }
      }
      if (
        !isNaN(this.businessId) &&
        this.businessId !== -1 &&
        this.businessId !== null
      ) {
        formData.businessId = this.businessId;
      } else {
        delete formData.businessId;
      }

      if (formData.workPlaceId === -1) {
        delete formData.workPlaceId;
      }
      if (formData.buildingId === -1) {
        delete formData.buildingId;
      }
      if (formData.floorId === -1) {
        delete formData.floorId;
      }
      console.log(formData);
      await this.#DashboardService
        .getReservationsHeatMapImage(formData)
        .subscribe({
          next: resp => {
            const reply = resp.reply.data;
            this.fin = resp.reply.endDate;
            this.inicio = resp.reply.startDate;
            //DATA
            reply.forEach((data: any) => {
              this.coordinates.push({
                x: Math.round(data.X * this.porcentaje),
                y: Math.round(data.y * this.porcentaje),
                value: data.heat * 10,
              });
            });
            this.updateHeatmap();
          },
        });
    }
  }

  calculateMinMaxCoord(): void {
    if (!this.coordinates.length) {
      return;
    }
    this.xMinCoord = this.coordinates[0].x;
    this.xMaxCoord = 0;
    this.yMinCoord = this.coordinates[0].y;
    this.yMaxCoord = 0;
    this.coordinates.forEach(element => {
      if (element.x < this.xMinCoord) {
        this.xMinCoord = element.x;
      }
      if (element.y < this.yMinCoord) {
        this.yMinCoord = element.y;
      }
      if (element.x > this.xMaxCoord) {
        this.xMaxCoord = element.x;
      }
      if (element.y > this.yMaxCoord) {
        this.yMaxCoord = element.y;
      }
    });
  }
  downloadExcel() {
    const business = Cookies.get('bussinesId')?.toString();

    let formData: any = {
      filter: this.filter,
      businessId: this.businessId !== -1 ? this.businessId : undefined,
      workPlaceId: this.workPlaceId !== -1 ? this.workPlaceId : undefined,
      buildingId: this.buildingId !== -1 ? this.buildingId : undefined,
      floorId: this.floorId !== -1 ? this.floorId : undefined,
    };
    if (this.cookieRole !== 'SYSADMIN') {
      if (business !== null) {
        formData.businessId = business;
      }
    }
    if (
      !isNaN(this.businessId) &&
      this.businessId !== -1 &&
      this.businessId !== null
    ) {
      formData.businessId = this.businessId;
    } else {
      delete formData.businessId;
    }

    if (formData.workPlaceId === -1) {
      delete formData.workPlaceId;
    }
    if (formData.buildingId === -1) {
      delete formData.buildingId;
    }
    if (formData.floorId === -1) {
      delete formData.floorId;
    }
    console.log(formData);
    this.#DashboardService
      .getReservationReservariosMapaCalorCountsCSV(formData)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: Blob) => {
        console.log('data', data);
        if (data.type == 'application/json') {
          this.alertService.warning('No hay datos para descargar.');
        } else {
          const file = new Blob([data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'reporte_lugares_mas_ocupados.xlsx';
          link.click();
          window.URL.revokeObjectURL(url);
        }
      });
  }

  imgsysadmin = '';
  idlogoSeleccionado: number = -1;
  loadLogo() {
    this.imgsysadmin = '';
    this.idlogoSeleccionado = -1;
    if (this.cookieRole === 'SYSADMIN') {
      for (const business of this.bussinesForLogo) {
        if (business.idBusiness === this.selectValueCompani) {
          this.idlogoSeleccionado = business.idLogo || 0;
        }
      }
    } else if (this.cookieRole === 'ADMINISTRADOR') {
      const logo = Cookies.get('logo');
      this.idlogoSeleccionado = logo ? Number(logo) : 0;
    }

    // Obtener el logo correspondiente
    if (this.idlogoSeleccionado > 0) {
      this.logoService.getOneLogo(this.idlogoSeleccionado).subscribe({
        next: ({ reply }) => {
          this.imgsysadmin = reply.value;
          console.log('imagen en base 64', this.imgsysadmin);
        },
      });
    } else {
      const imgElement = new Image();
      imgElement.onload = () => {
        // Convertir la imagen alternativa a base64 cuando se genere el PDF
        this.imgsysadmin = imgElement.src;
        console.log('imagen alternativa cargada', this.imgsysadmin);
      };
      imgElement.src = '../../../../../assets/icon.png';
    }
  }

  downloadPDF() {
    if (this.dataSource.data.length === 0) {
      this.alertService.error(
        'No hay datos disponibles para generar el reporte'
      );
      return;
    }

    if (this.valueNivel !== -1) {
      const canvasElement = document.getElementById(
        'graficaCalor'
      ) as HTMLCanvasElement;

      html2canvas(canvasElement).then(reservationCanvas => {
        const reservationImgData = reservationCanvas.toDataURL('image/png');
        const pdf = new jspdf.jsPDF('p', 'mm', 'letter');

        const leftMargin = 21;
        const rightMargin = 25;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const usableWidth = pageWidth - leftMargin - rightMargin;

        const logoWidth = 15;
        const logoHeight = 15;

        const agregarEncabezado = (pageNum: number) => {
          if (this.imgsysadmin) {
            const logoX = leftMargin;
            const logoY = 5;
            pdf.addImage(
              this.imgsysadmin,
              'PNG',
              logoX,
              logoY,
              logoWidth,
              logoHeight
            );
          }

          const titleText = 'Reporte de lugares más ocupados';
          const titleFontSize = 18;
          const titleTextWidth =
            (pdf.getStringUnitWidth(titleText) * titleFontSize) /
            pdf.internal.scaleFactor;
          const titleX = (pageWidth - titleTextWidth) / 2;
          const titleY = 40;

          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(titleFontSize);
          pdf.text(titleText, titleX, titleY - 25);

          const staticText = `Del: ${this.inicio}         Al: ${this.fin}`;
          const staticTextFontSize = 12;
          const staticTextWidth =
            (pdf.getStringUnitWidth(staticText) * staticTextFontSize) /
            pdf.internal.scaleFactor;
          const staticTextX = (pageWidth - staticTextWidth) / 2;
          const staticTextY = titleY - 18;

          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(staticTextFontSize);
          pdf.text(staticText, staticTextX, staticTextY);

          pdf.setFontSize(10);
        };

        const agregarPieDePagina = () => {
          pdf.setFontSize(12);
          const currentDate = new Date();
          const formattedDate = `${currentDate.toLocaleDateString()} ${currentDate.toLocaleTimeString()}`;
          const footerY = pdf.internal.pageSize.height - 10;
          const user = Cookies.get('username');
          pdf.setTextColor(0, 0, 0);

          pdf.setTextColor(0, 0, 255);
          pdf.setFont('helvetica');
          pdf.setFontSize(10);
          pdf.text(
            formattedDate,
            pageWidth - rightMargin - pdf.getTextWidth(formattedDate),
            footerY
          );
          pdf.setTextColor(0, 0, 255);

          pdf.text(
            `Usuario: ${user}`,
            pageWidth - rightMargin - pdf.getTextWidth(`Usuario: ${user}`),
            footerY + 5
          );
          pdf.setTextColor(0, 0, 0);
        };

        let currentPage = 1;
        let graphY = 30;

        const addContentToPage = () => {
          agregarEncabezado(currentPage);

          const imageAspectRatio =
            reservationCanvas.width / reservationCanvas.height;
          let graphWidth = usableWidth;
          let graphHeight = graphWidth / imageAspectRatio;

          if (graphHeight > pageHeight / 2) {
            graphHeight = pageHeight / 2;
            graphWidth = graphHeight * imageAspectRatio;
          }

          pdf.addImage(
            reservationImgData,
            'PNG',
            leftMargin,
            graphY,
            graphWidth,
            graphHeight
          );

          graphY += graphHeight + 10;

          const tableData = this.dataSource.data.map(element => ({
            edificio: element.edificio,
            nivel: element.nivel,
            puesto: element.puesto,
            frecuencia: element.frecuencia,
          }));

          const tableHeaders = [
            'Edificio',
            'Nivel',
            'Puestos de trabajo',
            'Frec.',
          ];
          const cellPadding = 3;
          const rowHeight = 5;
          const columnWidths = [72, 45, 45, 12];

          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10);
          let currentX = leftMargin;
          tableHeaders.forEach((header, index) => {
            pdf.rect(currentX, graphY, columnWidths[index], rowHeight);
            pdf.text(header, currentX + cellPadding, graphY + 4);
            currentX += columnWidths[index];
          });

          graphY += rowHeight;

          const maxRowsPerPage = Math.floor(
            (pageHeight - graphY - 20) / rowHeight
          );

          const splitText = (text: string, maxWidth: number) => {
            const words = text.split(' ');
            const lines = [];
            let currentLine = words[0];

            for (let i = 1; i < words.length; i++) {
              const word = words[i];
              const width = pdf.getTextWidth(`${currentLine} ${word}`);
              if (width < maxWidth) {
                currentLine += ` ${word}`;
              } else {
                lines.push(currentLine);
                currentLine = word;
              }
            }
            lines.push(currentLine);
            return lines;
          };

          pdf.setFont('helvetica', 'normal');
          let index = 0;
          let remainingRows = tableData.length;
          while (remainingRows > 0) {
            if (graphY + rowHeight > pageHeight - 20) {
              agregarPieDePagina();
              currentPage++;
              pdf.addPage();
              graphY = 30;
              agregarEncabezado(currentPage);

              pdf.setFont('helvetica', 'bold');
              pdf.setFontSize(10);
              currentX = leftMargin;
              tableHeaders.forEach((header, index) => {
                pdf.rect(currentX, graphY, columnWidths[index], rowHeight);
                pdf.text(header, currentX + cellPadding, graphY + 4);
                currentX += columnWidths[index];
              });
              pdf.setFont('helvetica', 'normal');
              graphY += rowHeight;
            }

            const row = tableData[index];
            currentX = leftMargin;
            const cellLines = [
              splitText(
                String(row.edificio),
                columnWidths[0] - cellPadding * 2
              ),
              splitText(String(row.nivel), columnWidths[1] - cellPadding * 2),
              splitText(String(row.puesto), columnWidths[2] - cellPadding * 2),
              splitText(
                String(row.frecuencia),
                columnWidths[3] - cellPadding * 2
              ),
            ];
            const maxLines = Math.max(...cellLines.map(lines => lines.length));
            const cellHeight = rowHeight * maxLines;

            [row.edificio, row.nivel, row.puesto, row.frecuencia].forEach(
              (cell, i) => {
                const lines = cellLines[i];
                lines.forEach((line, lineIndex) => {
                  pdf.rect(currentX, graphY, columnWidths[i], cellHeight);
                  pdf.text(
                    line,
                    currentX + cellPadding,
                    graphY + 4 + rowHeight * lineIndex
                  );
                });
                currentX += columnWidths[i];
              }
            );

            graphY += cellHeight;
            remainingRows--;
            index++;
          }
        };

        addContentToPage();
        agregarPieDePagina();

        pdf.save('Reporte de lugares más ocupados');
      });
    } else {
      this.alertService.error('Seleccione un nivel para generar el reporte');
    }
  }

  async chargeImage() {
    this.floorService.getFloorMap(this.floorId.toString()).subscribe({
      next: async request => {
        if (request.code === 10000) {
          const base64Image = request.reply[0].map || '';
          this.imgSource.set(base64Image);

          await this.getImageDimensions(base64Image)
            .then(dimensions => {
              console.log(
                `Width: ${dimensions.width}, Height: ${dimensions.height}`
              );

              if (dimensions.width >= 1000 || dimensions.height >= 1000) {
                this.porcentaje = 0.7;
              } else if (dimensions.width >= 450 || dimensions.height >= 450) {
                this.porcentaje = 0.8;
              } else if (dimensions.width <= 450 || dimensions.height <= 450) {
                this.porcentaje = 1;
              }
              console.log('porcentaje', this.porcentaje);
              this.imageWidth = dimensions.width * this.porcentaje;
              this.imageHeight = dimensions.height * this.porcentaje;
              this.refreshHeatmap();
            })
            .catch(error => {
              console.error('Error al cargar la imagen:', error);
            });
        }
      },
      complete: () => {
        //this.isLoading = false;
        // Llama a la función createImg después de que la imagen se haya cargado
      },
    });
  }
  getImageDimensions(
    base64Image: string
  ): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };

      img.onerror = error => {
        reject(new Error('No se pudo cargar la imagen.'));
      };

      img.src = base64Image;
    });
  }

  chargeSizeImage(): string {
    const heatmapContainer =
      this.el.nativeElement.querySelector('#heatmapContainer');
    this.renderer.setStyle(heatmapContainer, 'width', `${this.imageWidth}px`);
    this.renderer.setStyle(heatmapContainer, 'height', `${this.imageHeight}px`);
    return `width: ${this.imageWidth}px; height: ${this.imageHeight}px`;
  }
}

export interface Coordinate {
  x: number;
  y: number;
  value: number;
}
